import { render, staticRenderFns } from "./dashboard-top-views.vue?vue&type=template&id=32227c10&"
import script from "./dashboard-top-views.vue?vue&type=script&lang=js&"
export * from "./dashboard-top-views.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports